












import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "TermsAndConditions"
})
export default class TermsAndConditions extends Vue {}
